module.exports = __webpack_public_path__ + "static/food-desktop-d4f40e164d41489b3aec0b0372319d1f.png";